module.exports = __webpack_public_path__ + "img/firmeAqui.4b13084f.png";